// extracted by mini-css-extract-plugin
module.exports = {"hideable":"Keys_hideable__1E-BH","keys":"Keys_keys__1lfdM","actions":"Keys_actions__2_NgQ","legend":"Keys_legend__1Rpxk"};